import { render, staticRenderFns } from "./StockIn.vue?vue&type=template&id=8dac252c"
import script from "./StockIn.vue?vue&type=script&lang=js"
export * from "./StockIn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports